export default {
  getStory(context, page) {
    let devPreview = null

    if (
      (window.location?.origin?.includes('deploy-preview-') &&
        window.location?.search?.includes('storyblok')) ||
      context.route.query?._storyblok_version === 'draft'
    ) {
      devPreview = true
    }

    // if (window?.location?.pathname.includes('/testing/')) {
    //   devPreview = true
    // }

    // console.log(
    //   window.location,
    //   window.location?.origin?.includes('deploy-preview-') &&
    //     window.location?.search?.includes('storyblok')
    // )

    return context.app.$storyapi
      .get(`cdn/stories/${page}`, {
        version: context.isDev || devPreview ? 'draft' : 'published',
      })
      .then((res) => {
        return res.data
      })
      .catch((res) => {
        if (!res.response) {
          console.error('err: ' + res)
          context.error({
            statusCode: 404,
            message: 'Failed to receive content form api',
          })
        } else {
          console.error(res.response.data)
          context.error({
            statusCode: res.response.status,
            message: res.response.data,
          })
        }
      })
  },
  // getVersion(context) {
  //   return context.app.$storyapi.get(`cdn/spaces/me`).then((res) => {
  //     return res.data.space.version
  //   })
  // },
}
